export default __webpack_public_path__ + "static/media/Zoo_FlamingoAd@2x.ef7eb7c3.jpg";